<mat-card class="decoration-card">
    <mat-card-content>
        <mat-toolbar>
            <mat-paginator #paginator class="demo-paginator" (page)="handlePageEvent($event)" 
              [length]="pageLength"
              [pageSize]="pageSize" 
              [disabled]="disabled" 
              [showFirstLastButtons]="showFirstLastButtons"
              [pageSizeOptions]="showPageSizeOptions ? pageSizeOptions : []" 
              [hidePageSize]="hidePageSize"
              [pageIndex]="pageIndex" 
              aria-label="Select page">
            </mat-paginator>

            <span class="example-spacer"></span>

            <input type="file" class="file-input" (change)="onFileSelected($event)" #fileUpload>
            <button mat-icon-button class="crud_action" matTooltip="append a photo" (click)="fileUpload.click()" *ngIf="!isReadonly">
              <mat-icon>plus_one</mat-icon>
            </button>

            <button mat-icon-button class="crud_action" matTooltip="delete the current photo" (click)="deletePhoto()" *ngIf="!isReadonly">
              <mat-icon>delete_outline</mat-icon>
            </button>
        
        </mat-toolbar>

        <div class="upload-container" *ngIf="!isReadonly">
          <!-- 拖放区域 -->
          <div 
            class="drop-zone"
            [class.dragging]="isDragging"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave()"
            (drop)="onDrop($event)" 
          >
            <div class="content" >
              <mat-icon (click)="fileUpload.click()">cloud_upload</mat-icon>
              <p>Drag and drop files here</p>
              <span>Support: png/jpeg/jpg, Max {{maxSizeMB}}MB</span>
            </div>

          </div>

          <!-- 文件信息 -->
          <div class="file-info" *ngIf="selectedFile">
            <p><strong>Selected:&nbsp;&nbsp;</strong>{{selectedFile.name}}</p>
            <p><strong>Size:&nbsp;&nbsp;</strong>{{(selectedFile.size / 1024 / 1024).toFixed(2)}} MB</p>
          </div>

          <!-- 错误提示 -->
          <div class="error" *ngIf="uploadError">
            {{uploadError}}
          </div>

        </div>

        <div class="vessel-image-container" *ngIf="imgFromApi">
            <img class="vessel-image" [src]="imgFromApi" alt="vessel image">
        </div>

      </mat-card-content>
</mat-card>